import type { ReactNode } from 'react';

export function AuthPage({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#5D1828] via-[#7A2235] to-[#8B2E3F] flex items-center justify-center p-4">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(45deg, transparent 48%, white 49%, white 51%, transparent 52%),
            linear-gradient(-45deg, transparent 48%, white 49%, white 51%, transparent 52%)
          `,
          backgroundSize: '20px 20px'
        }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>

      {/* Footer */}
      <div className="absolute bottom-4 left-0 right-0 text-center text-white/70 text-sm">
        <p>Sistema Municipal de Gestión Política</p>
      </div>
    </div>
  );
}
